import React, { useState, useCallback } from 'react';
import { DatePicker } from '@Sage/hoi-poi-ui';
import { connect } from 'react-redux';

import { default as isDateFn } from 'date-fns/isDate';
import { es, enGB, enUS, de, fr, it, pt, ru, ptBR, da } from 'date-fns/locale';
import { default as dateFormat } from 'date-fns/format';

export const LOCALE_DATES = {
    'es-ES': es,
    es: es,
    'en-GB': enGB,
    en: enGB,
    'en-US': enUS,
    'de-DE': de,
    'fr-FR': fr,
    'it-IT': it,
    'pt-PT': pt,
    'ru-RU': ru,
    'pt-BR': ptBR,
    'da-DK': da,
};

export function formatDate(date, locale = 'en-US', format = 'P p') {
    let d = date;
    if (!isDateFn(d)) d = new Date(date);
    return dateFormat(d, format, {
        locale: LOCALE_DATES[locale],
    });
}

function mapStateToProps({ authentication }) {
    return {
        user: authentication.user,
    };
}

function CrudDates({ user, className, input, ...props }) {
    const [finalValue, setValue] = useState(input.value);

    const format = useCallback(
        (value) => {
            return formatDate(value, user.locale, 'P');
        },
        [user.locale],
    );

    const onChange = (value) => {
        setValue(value || null);
        input.onChange && input.onChange(value || null);
    };

    return (
        <div className="input-datepicker">
            <DatePicker
                lang={user.lang}
                value={finalValue}
                formatDate={format}
                onChange={onChange}
                isFullWidth
                {...props}
            />
        </div>
    );
}

export default connect(mapStateToProps)(CrudDates);
